import {Layers, RockBottomLayers, SimpleStageLayer} from "./RockBottomLayers";
import {RockBottomGameConfig} from "../RockBottomGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {RockBottom} from "../RockBottom";
import {TimelineLite} from "gsap";

export class RockBottomAnticipationView extends PIXI.Container {
    private _layer: SimpleStageLayer | undefined;

    constructor() {
        super();
        this.init();
    }

    public toggleScatterAnticipation(reelId: number, show: boolean): void {
        if (!(RockBottom.inBonusGame)) {
            const animChildIdx: number = reelId - 2,
                tl: TimelineLite = new TimelineLite(),
                pngAnim: TimelineSprite = this.getChildAt(animChildIdx) as TimelineSprite;

            tl.to(pngAnim, {
                alpha: show ? 1 : 0,
                duration: RockBottomGameConfig.FADE_DUR_ANTICIPATION,
                onStart: () => {
                    if (show) {
                        pngAnim.playLoop();
                        pngAnim.show();
                    }
                },
                onComplete: () => {
                    if (!show) {
                        pngAnim.hide();
                        pngAnim.stopLoop();
                    }
                }
            });
        }
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.ANTICIPATION_VIEW);
        this.createAnims();
        this._layer?.addChild(this);
    }

    private createAnims(): void {
        for (let i: number = 2; i < RockBottomGameConfig.REELS_NUM; i++) {
            const pngSeq: TimelineSprite = new TimelineSprite(RockBottom.assetLoader.getTextures("scatterAnticipation"));
            pngSeq.anchor.set(0.5);
            pngSeq.scale.set(1.5, (i === 4) ? 1.12 : 1.5);
            pngSeq.position.set((360 + ((i - 2) * RockBottomGameConfig.SYMBOL_WIDTH)), 360);
            pngSeq.name = "reelAnti_" + i;
            pngSeq.alpha = 0;
            pngSeq.hide();
            this.addChild(pngSeq);
        }
    }
}